export  class PasswordLevel{
    public static readonly PASSWORD_HIGH = 1;
    public static readonly PASSWORD_MEDIUM = 2;
    public static readonly PASSWORD_LOW = 3;
}
